import {
    CHANGE_INPUT,
    CHANGE_INPUT_2,
    SET_CHAIN,
    SET_GOLD_COLOR,
    SET_NECKLACE_LENGTH,
    SET_BRACELET_LENGTH,
    SET_NECKLACE_ORIENTATION,
    SET_EARRING_INPUT,
    SET_BRACELET_ORIENTATION,
    SET_EARRING_QUANTITY,
    SET_RING_SIZE,
    SET_CHARM_ORIENTATION,
    LOAD_STATE
} from './actions';
import {NECKLACE, GOLD, NECKLACELENGTH, CHAIN, CHARM, BRACELET, EARRING} from "../../constants";

const initialState = {
    necklaceOrientation: NECKLACE.STANDARD,
    necklaceLength: NECKLACELENGTH.LENGTH15,
    charmOrientation: CHARM.ONELINE,
    earringQuantity: EARRING.ONE,
    braceletOrientation: BRACELET.STANDARD,
    chain: CHAIN.BEAD,
    goldColor: GOLD.YG,
    input: 'ABC',
    input2: 'ABC',
    earringInput: ['ABC', 'DEF', 'GHI', 'KLM'],
    braceletLength: 7.5,
    ringSize: 9,
};

export default function App(state = initialState, action) {
    switch (action.type) {
        case SET_NECKLACE_ORIENTATION:
            return Object.assign({}, state, {
                necklaceOrientation: action.necklaceOrientation,
            });

        case SET_BRACELET_ORIENTATION:
            return Object.assign({}, state, {
                braceletOrientation: action.braceletOrientation,
            });

        case SET_CHARM_ORIENTATION:
            return Object.assign({}, state, {
                charmOrientation: action.charmOrientation,
            });

        case SET_EARRING_QUANTITY:
            return Object.assign({}, state, {
                earringQuantity: action.earringQuantity,
            });

        case SET_CHAIN:
            return Object.assign({}, state, {
                chain: action.chain,
            });

        case SET_GOLD_COLOR:
            return Object.assign({}, state, {
                goldColor: action.goldColor,
            });

        case SET_NECKLACE_LENGTH:
            return Object.assign({}, state, {
                necklaceLength: action.necklaceLength,
            });

        case SET_BRACELET_LENGTH:
            return Object.assign({}, state, {
                braceletLength: action.braceletLength,
            });

        case SET_RING_SIZE:
            return Object.assign({}, state, {
                ringSize: action.ringSize,
            });

        case CHANGE_INPUT:
            return Object.assign({}, state, {
                input: action.input,
            });

        case CHANGE_INPUT_2:
            return Object.assign({}, state, {
                input2: action.input2,
            });

        case SET_EARRING_INPUT:
            return Object.assign({}, state, {
                earringInput: action.earringInput,
            });

        case LOAD_STATE:
            return Object.assign({}, state, action.state);

        default:
            return state;
    }
}

